if (document.querySelector("#rt-pspr-form")) {
	import("./front/productPage").then(({ productPage }) => {
		productPage();
	});
}

if (document.querySelector(".rt-pspr-template-wrapper")) {
	import("./front/ProductPageLayoutAdjustments").then(
		(e) => new e.ProductPageLayoutAdjustments(),
	);
}
